module.exports = __webpack_public_path__ + "static/media/Icon-store.e65f3056.svg";